import { createApp, nextTick } from 'vue';
import base64 from '@js/modules/utils/base64';
import NodeToolbox from '@v/NodeToolbox.vue';
import ShareModal from '@v/ShareModal.vue';
import MarkingModal from '@v/MarkingModal.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';

import { showShareModal, showMarkingModal } from '@js/modules/parts/share';

const header_part = createApp({
    data: () => {
        return {
            book: null
        }
    } ,
    components: {
        NodeToolbox,
        ShareModal,
        MarkingModal,
    },
    methods:{
        showShareModal,
        showMarkingModal,
        showInfo() {
            Swal.fire({
                icon: 'info',
                title: (<HTMLInputElement>document.getElementById('book_name')).value,
                text: (<HTMLInputElement>document.getElementById('book_description')).value,
            });
        },
    },
    mounted(){
        nextTick(async () => {
            const v = <HTMLInputElement>document.getElementById('header_book');
            if (v && v.value) {
                const book = await base64.decode(v.value, 'UTF-8');
                this.book = JSON.parse(book);
            }
        });
    }
});

header_part.mount('#header_part');

